exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".vs-switch{height:38px;width:118px!important;font-size:2rem;margin-left:15px}.switch-place-view{width:188px!important}.switch-archived-view{width:130px!important}.vs-circle-switch{width:34px!important;height:34px!important}.vs-switch.vs-switch-active .vs-circle-switch,.vs-switch.vs-switch-active:active .vs-circle-switch{margin-left:calc(100% - 38px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-1458c38a!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/components/YearMonthForm.vue
// module id = 219
// module chunks = 0